export const messages = {
  en: {
    reserveParamsManage: {
      search: {
        title: 'Search Conditions',
        namePlaceholder: 'Please enter parameter name'
      },
      list: {
        title: 'Reservation Parameters'
      },
      table: {
        name: 'Parameter Name',
        paramWay: 'Reservation Method',
        startTime: 'Start Time',
        maxQuantity: 'Max Quantity',
        hoursMaxQuantity: 'Quantity Per Time',
        operation: 'Operation'
      },
      day: 'Day',
      week: 'Week',
      dayUnit: 'th',
      hour: 'o\'clock',
      setTime: 'Set Time',
      deleteTitle: 'Delete Confirmation',
      deleteConfirm: 'Warning',
      deleteTip: 'Are you sure to delete this reservation parameter? This operation cannot be undone!',
      setTimeTitle: 'Set Open Time',
      selectStatus: 'Select Status',
      canReserve: 'Available',
      cannotReserve: 'Unavailable',
      addTitle: 'Add Reservation Parameter',
      editTitle: 'Edit Reservation Parameter',
      name: 'Parameter Name',
      namePlaceholder: 'Please enter parameter name',
      nameRequired: 'Parameter name is required',
      paramWay: 'Reservation Method',
      paramWayPlaceholder: 'Please select reservation method',
      paramWayRequired: 'Reservation method is required',
      days: 'Days',
      weekdays: 'Weekdays',
      startTime: 'Start Time',
      startTimePlaceholder: 'Please select start time',
      startTimeRequired: 'Start time is required',
      maxQuantity: 'Max Quantity',
      maxQuantityPlaceholder: 'Please enter max quantity',
      maxQuantityRequired: 'Max quantity is required',
      hoursMaxQuantity: 'Quantity Per Time',
      hoursMaxQuantityPlaceholder: 'Please enter quantity per time',
      hoursMaxQuantityRequired: 'Quantity per time is required',
      fetchError: 'Failed to fetch reservation parameters',
      page: {
        subtitle: 'Maintain reservation windows, quotas and cycle rules',
        empty: 'No reservation parameter data',
        loadFailed: 'Failed to load reservation parameter list'
      }
    }
  },
  zh: {
    reserveParamsManage: {
      search: {
        title: '查询条件',
        namePlaceholder: '请输入参数名称'
      },
      list: {
        title: '预约参数'
      },
      table: {
        name: '参数名称',
        paramWay: '预约方式',
        startTime: '开始时间',
        maxQuantity: '预约次数',
        hoursMaxQuantity: '预约数量',
        operation: '操作'
      },
      day: '日',
      week: '周',
      dayUnit: '日',
      hour: '点',
      setTime: '设置时间',
      deleteTitle: '删除确认',
      deleteConfirm: '警告',
      deleteTip: '确定删除该预约参数吗？此操作不可撤销！',
      setTimeTitle: '设置开放时间',
      selectStatus: '选择状态',
      canReserve: '可预约',
      cannotReserve: '不可预约',
      addTitle: '添加预约参数',
      editTitle: '编辑预约参数',
      name: '参数名称',
      namePlaceholder: '请输入参数名称',
      nameRequired: '参数名称不能为空',
      paramWay: '预约方式',
      paramWayPlaceholder: '请选择预约方式',
      paramWayRequired: '预约方式不能为空',
      days: '日',
      weekdays: '工作日',
      startTime: '开始时间',
      startTimePlaceholder: '请选择开始时间',
      startTimeRequired: '开始时间不能为空',
      maxQuantity: '预约次数',
      maxQuantityPlaceholder: '请输入预约次数',
      maxQuantityRequired: '预约次数不能为空',
      hoursMaxQuantity: '预约数量',
      hoursMaxQuantityPlaceholder: '请输入预约数量',
      hoursMaxQuantityRequired: '预约数量不能为空',
      fetchError: '获取预约参数失败',
      page: {
        subtitle: '维护预约时段、次数上限与周期规则',
        empty: '暂无预约参数数据',
        loadFailed: '获取预约参数列表失败'
      }
    }
  }
}